import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LOGIN_COMPONENTS, LOGIN_SERVICES} from "@ispm/migration/components/login-component/index";
import {DlsSharedModule} from "../../../dls-shared.module";
import {CoreModule} from "@ispm/core/core.module";
import {LayoutModule} from "@ispm/layout/layout.module";
import {CommonModule as WuitkCommonModule} from '@wuitk/angular/components/common';
import {LoginAuthModule} from "../../../authorization/login-auth.module";
import {NotificationModule} from "@ispm/dashboard/notification/notification.module";
import {ConfigurationModule} from "../../../configuration/configuration.module";
import {NavigationModule} from "@ispm/navigation/navigation.module";
import {DashboardModule} from "@ispm/dashboard/dashboard.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DlsSharedModule,
    DashboardModule,
    LoginAuthModule.forRoot(),
    ConfigurationModule.forRoot(),
    CoreModule,
    LayoutModule,
    WuitkCommonModule,
    NavigationModule
  ],
  declarations: [...LOGIN_COMPONENTS],
  exports: [...LOGIN_COMPONENTS],
  providers: [...LOGIN_SERVICES]
})
export class ISPMLoginModule { }
